<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.integration')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.integration')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('shared.integration')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button class="btn btn-primary btn-sm" @click="getSettings()">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="form-group">
                <label>Kişiler Son Aktarım Tarihi</label>
                <input v-model="sonGuncellemeZamani" type="datetime-local" class="form-control" />
              </div>
              <div class="form-group">
                <label>Departmanlar Son Aktarım Tarihi</label>
                <input v-model="sonGuncellemeZamani2" type="datetime-local" class="form-control" />
              </div>
              <div class="form-group">
                <label>İzinler Son Aktarım Tarihi</label>
                <input v-model="sonGuncellemeZamani3" type="datetime-local" class="form-control" />
              </div>
              <button
                class="btn btn-primary"
                style="width:100%;"
                @click="goToHangfire()"
              >{{$ml.get('integration.triggerTransfers')}}</button>
            </div>
            <div class="overlay" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="row">
            <div class="col-sm-12">
              <div class="box box-primary">
                <div class="box-header">
                  <i class="fa fa-setting"></i>
                  <h3 class="box-title">
                    <span>Entegrasyon Olayları</span>
                  </h3>
                  <div class="pull-right">
                    <button
                      v-show="logList.length > 0"
                      @click="exportToPDF()"
                      type="button"
                      class="btn btn-danger btn-sm"
                    >
                      <i class="fa fa-share"></i>
                      {{$ml.get('general.exportToPdfOrPrint')}}
                    </button>
                  </div>
                </div>
                <div class="box-body">
                  <div class="input-group" style="margin-bottom:10px;">
                    <input type="datetime-local" v-model="startDate" class="form-control" />
                    <span class="input-group-addon">-</span>
                    <input type="datetime-local" v-model="endDate" class="form-control" />
                    <span class="input-group-btn">
                      <button
                        @click="send()"
                        type="button"
                        class="btn btn-primary"
                        style="width:100%;"
                      >
                        <i class="fa fa-search"></i>
                        {{$ml.get('general.view')}}
                      </button>
                    </span>
                  </div>
                  <div
                    id="printReport"
                    v-show="logList.length > 0"
                    class="table-responsive no-padding"
                    :style="windowHeightSize"
                  >
                    <div align="center">
                      <span>Entegrasyon Olayları ({{this.startDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.endDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                    </div>
                    <table class="table table-hover">
                      <thead>
                        <tr style="text-align: left;">
                          <th>İşlem Id</th>
                          <th>Zaman</th>
                          <th>Olay</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="log in logList" :key="log.id" class="rows">
                          <td>
                            <span>{{log.id}}</span>
                          </td>
                          <td>
                            <span>{{log.zaman | toDateFormatGet}}</span>
                          </td>
                          <td>
                            <span>{{log.olay}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="logList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    Olay kaydı bulunamadı.
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoadingDetail">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      startDate: null,
      endDate: null,
      sonGuncellemeZamani: null,
      sonGuncellemeZamani2: null,
      sonGuncellemeZamani3: null,
      logs: []
    };
  },
  filters: {
    toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    baseUrl() {
      return this.$store.getters.getBaseURL;
    },
    logList() {
      return this.logs;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    allTransferOperations() {
      var url = this.baseUrl + "/hangfire";
      window.open(url, "_blank");
    },
    async goToHangfire() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .post("/Integration", {
            date1: this.sonGuncellemeZamani,
            date2: this.sonGuncellemeZamani2,
            date3: this.sonGuncellemeZamani3
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("alerts.transfersTriggeredSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getSettings() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/Integration/Settings")
          .then(response => {
            if (response.status == 200) {
              this.sonGuncellemeZamani = response.data.sonGuncellemeZamani;
              this.sonGuncellemeZamani2 = response.data.sonGuncellemeZamani2;
              this.sonGuncellemeZamani3 = response.data.sonGuncellemeZamani3;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    async send() {
      if ((this.startDate == null) | (this.endDate == null)) {
        alertify.warning(this.$ml.get("alerts.pleaseCheckEnteredValue"));
        return;
      }
      try {
        this.isLoadingDetail = true;
        const logs = [];
        var startDate = this.startDate;
        var endDate = this.endDate;
        const response = await this.$axios
          .get(
            "/Integration/Log?startDate=" + startDate + "&endDate=" + endDate
          )
          .then(response => {
            response.data.forEach(doc => {
              logs.push({
                id: doc.id,
                zaman: doc.zaman,
                olay: doc.olay
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.logs = logs;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    this.getSettings();
    this.getDefaultDate();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/integration/Integration.vue